<script>
    import { user_info } from "../util/stores";

    let copyright_year = new Date().getFullYear();
</script>

<div class="footer">
    <hr>
    &copy; 2021-{copyright_year} Virtuo
    <ul>
        {#if $user_info.data}
        <li><a href="/invite">Invite</a></li>
        {/if}
        <li><a href="/whitelist">Whitelist</a></li>
        <li><a href="/">Home</a></li>
    </ul>
</div>

<style>
    .footer {
        font-size: 14px;
        padding-bottom: 25px;
    }

    .footer hr {
        margin-bottom: 25px;
    }

    .footer ul li {
        text-decoration: none;
        color: #4678e4;
        padding: 5px 15px;
        border-radius: 99px;
    }

    .footer ul li:hover {
        background-color: #eeeeee;
    }

    .footer ul li {
        display: inline;
        float: right;
        margin: 0 5px;
    }

    .footer ul {
        display: inline;
    }
</style>